import { useState } from "react";

export const GetWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);
  function report() {
    setWidth(window.innerWidth);
  }
  window.onresize = report;
  return width;
};
